import { isEmpty } from 'lodash';

export const parseFullName = (firstName, lastName) => {
  if (!isEmpty(firstName) && !isEmpty(lastName)) {
    return `${firstName} ${lastName}`;
  } else if (!isEmpty(firstName)) {
    return `${firstName}`;
  } else {
    return '';
  }
};

/** First/last only — no company preference (e.g. downline search placeholder). */
export function getRepPersonalName(obj) {
  if (!obj) return '';
  return parseFullName(obj.FirstName || obj.firstName, obj.LastName || obj.lastName);
}

/** Human-readable display name for cards/avatar (company preferred when present). */
export function getRepDisplayName(obj) {
  if (!obj) return '';
  if (!isEmpty(obj.Company)) return obj.Company;
  return getRepPersonalName(obj);
}

export function getRepName(obj) {
  if (!obj) return '';
  return getRepDisplayName(obj) || obj.RepDID || '';
}
